import(/* webpackMode: "eager" */ "/home/runner/work/dodao-ui/dodao-ui/academy-ui/src/app/global-error.tsx");
